(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mv-collections-hub"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__mvCollectionsHub) return;
    window.__mvCollectionsHub = true;

    const scrollToId = (id, behavior) => {
      const target = id ? document.getElementById(id) : null;
      if (!target) return false;
      target.scrollIntoView({ behavior, block: 'start' });
      return true;
    };

    document.addEventListener('click', (event) => {
      const link = event.target instanceof Element ? event.target.closest('[data-mv-ch-jump]') : null;
      if (!link) return;
      const id = (link.getAttribute('href') || '').slice(1);
      if (scrollToId(id, 'smooth')) {
        event.preventDefault();
        history.replaceState(history.state, '', '#' + id);
      }
    });

    const init = () => {
      const root = document.querySelector('[data-mv-ch]');
      if (!root) return;
      if (location.hash) scrollToId(location.hash.slice(1), 'instant');

      // Keep the jump nav under Horizon's header when the header is sticky or slides back in on scroll-up.
      const nav = root.querySelector('.mv-ch__nav');
      const header = document.querySelector('#header-group header-component, header-component, #header-component, .header-section');
      if (nav && header) {
        let ticking = false;
        const sync = () => {
          ticking = false;
          const pos = getComputedStyle(header.closest('.shopify-section') || header).position;
          const r = header.getBoundingClientRect();
          const covering = (pos === 'sticky' || pos === 'fixed' || getComputedStyle(header).position === 'sticky' || getComputedStyle(header).position === 'fixed') && r.bottom > 0 && r.top <= 0.5;
          root.style.setProperty('--mv-ch-sticky-top', covering ? Math.round(r.bottom) + 'px' : '0px');
        };
        const onScroll = () => {
          if (!ticking) {
            ticking = true;
            requestAnimationFrame(sync);
          }
        };
        // Capture phase: on this theme the scroller can be an inner wrapper, whose scroll events never reach window.
        document.addEventListener('scroll', onScroll, { passive: true, capture: true });
        window.addEventListener('resize', onScroll);
        sync();
      }

      const links = [...root.querySelectorAll('.mv-ch__nav-link')];
      if (!links.length || !('IntersectionObserver' in window)) return;
      const byId = new Map(links.map((l) => [l.getAttribute('href').slice(1), l]));
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            links.forEach((l) => l.removeAttribute('aria-current'));
            const active = byId.get(entry.target.id);
            if (active) {
              active.setAttribute('aria-current', 'true');
              const list = active.closest('.mv-ch__nav-list');
              if (list) list.scrollTo({ left: active.offsetLeft - 16, behavior: 'smooth' });
            }
          });
        },
        { rootMargin: '-35% 0px -60% 0px' }
      );
      byId.forEach((_, id) => {
        const el = document.getElementById(id);
        if (el) io.observe(el);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mv-contact-form"] && !Shopify.designMode) return;
  try {
    
  // Shopify redirects back to the form anchor on post. Move focus to the confirmation (or the
  // error list) so screen readers and keyboard users land on the result instead of at the top of
  // a page that looks unchanged.
  (() => {
    const target = document.querySelector('.mv-cform__success, .mv-cform__errors');
    if (!target) return;
    target.scrollIntoView({ block: 'center', behavior: 'smooth' });
    target.focus({ preventScroll: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mv-lace-size-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const target = document.getElementById(url.hash.slice(1));
        if (target) {
          target.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // Jump chips: native hash navigation is swallowed on this theme, so scroll explicitly.
  // Delegated on document so it survives the section being re-rendered by the facets JS.
  if (!window.__mvSizeJump) {
    window.__mvSizeJump = true;
    document.addEventListener('click', (event) => {
      const chip = event.target instanceof Element ? event.target.closest('.mv-sg__chip') : null;
      if (!chip) return;
      const id = (chip.getAttribute('href') || '').slice(1);
      const target = id ? document.getElementById(id) : null;
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      history.replaceState(history.state, '', '#' + id);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mv-texture-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const target = document.getElementById(url.hash.slice(1));
        if (target) {
          target.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // Jump chips: native hash navigation is swallowed on this theme, so scroll explicitly.
  // Delegated on document so it survives the section being re-rendered by the facets JS.
  if (!window.__mvTextureJump) {
    window.__mvTextureJump = true;
    document.addEventListener('click', (event) => {
      const chip = event.target instanceof Element ? event.target.closest('.mv-tg__chip') : null;
      if (!chip) return;
      const id = (chip.getAttribute('href') || '').slice(1);
      const target = id ? document.getElementById(id) : null;
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      history.replaceState(history.state, '', '#' + id);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mv-wig-collection"]) return;
  try {
    
  if (!window.__mvWigJump) {
    window.__mvWigJump = true;
    document.addEventListener('click', (event) => {
      const chip = event.target instanceof Element ? event.target.closest('.mv-wg__chip') : null;
      if (!chip) return;
      const id = (chip.getAttribute('href') || '').slice(1);
      const target = id ? document.getElementById(id) : null;
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      history.replaceState(history.state, '', '#' + id);
    });
  }

  } catch(e) { console.error(e); }
})();
})();
